"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatusEnum = exports.ZCreateOrderResponse = exports.ZPaymentRequestSelect = exports.ZOrderSelect = exports.PurchasingActionEnum = exports.ZPurchasingAction = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZPurchasingAction = zod_1.z.nativeEnum(dbEnums_1.PurchasingAction);
exports.PurchasingActionEnum = dbEnums_1.PurchasingAction;
exports.ZOrderSelect = zodSchemas_generated_1.zodSelectOrder
    .pick({
    id: true,
    createdAt: true,
    status: true,
    playerId: true,
    isSubscription: true,
    totalFiatAmount: true,
    tokenAmount: true,
    paymentMethod: true,
    subscriptionId: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectOrder.shape, {
    createdAt: zod_1.z.coerce.date(),
}));
exports.ZPaymentRequestSelect = zodSchemas_generated_1.zodSelectPaymentRequest
    .pick({
    id: true,
    createdAt: true,
    status: true,
    purchasingAction: true,
    totalFiatAmount: true,
    balanceAmount: true,
    giftCardAmount: true,
    promoAmount: true,
    tokenAmount: true,
    discountAmount: true,
    paymentMethodAmount: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPaymentRequest.shape, {
    createdAt: zod_1.z.coerce.date(),
}));
exports.ZCreateOrderResponse = zod_1.z.object({
    orderId: zod_1.z.string(),
    adyenPaymentSession: zod_1.z
        .object({
        sessionData: zod_1.z.string(),
        id: zod_1.z.string(),
        adyenPaymentSessionId: zod_1.z.string(),
    })
        .optional(),
});
exports.OrderStatusEnum = exports.ZOrderSelect.shape.status.enum;
//# sourceMappingURL=models.js.map